var utils = require('../../utils')

export default {
  name: 'doctor-list',
  data: function () {
    return {
      shopId: '',
      doctorId: null,
      doctorName: '',
      clinicId: '',
      clinicName: '',
      duplicatedSearch: false,
      searchCallbackFlag: false, // 検索結果フラグ
      utils: utils,
      watchScroll: null,
      sortKey: '',
      sortStateOrder: '',
      sortState: {
        'doctor_name_furigana': {'state': true,  'order': true},
        'clinic_name_furigana': {'state': false, 'order': false},
        'mobile':               {'state': false, 'order': false}
      },
      sortStateInit: {}
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    if (utils.isPresent(this) && '$store' in this) {
      if (this.$store.getters.doctorsSearchParams !== null) {
        this.$store.getters.doctorsSearchParams['pageYOffset'] = window.pageYOffset // スクロール位置保存
        this.$store.getters.doctorsSearchParams['scrollHeight'] = utils.getScrollHeight() // スクロール高さ保存
      }
      if (this.watchScroll !== null) {
        this.watchScroll.disconnect()
        this.watchScroll = null
      }
    }
    utils.autocompleteEventRemove({$: $, elem:'#clinic_name_autocomplete'}) // オートコンプリートイベント削除
    utils.scrollBottomSearchEventRemove() // 最下部スクロールイベント削除
    next()
  },
  created() {
    var readMore = false
    var ssShopID = window.sessionStorage.getItem('dl-shopID')
    var ssClinicName = window.sessionStorage.getItem('dl-clinicName')
    var ssDoctorName = window.sessionStorage.getItem('dl-doctorName')
    var ssSortKey = window.sessionStorage.getItem("dl-sortKey")
    var ssSortStateOrder = window.sessionStorage.getItem("dl-sortStateOrder")
    if (!!ssShopID) {
      if (ssShopID === 'null') {
        this.shopId = null
      } else {
        this.shopId = ssShopID
      }
    } else {
      this.shopId = this.$store.getters.currentShopId
    }
    if (!!ssClinicName) {
      this.clinicName = ssClinicName
    }
    if (!!ssDoctorName) {
      this.doctorName = ssDoctorName
    }
    if (!!ssSortKey) {
      var key = ssSortKey
      this.sortKey = key
      if (ssSortStateOrder != null) {
        if (ssSortStateOrder === "true") {
          this.sortStateOrder = true
        } else {
          this.sortStateOrder = false
        }
      } else {
        this.sortStateOrder = !this.sortState[key].order
      }
      for (var k in this.sortState) {
        this.sortState[k].state = false
        if (k !== key) {
          this.sortState[k].order = false
        }
      }
      this.sortState[key].state = true
      this.sortState[key].order = this.sortStateOrder
    }
    // ソート初期化用保存
    for (var k in this.sortState) {
      this.sortStateInit[k] = {}
      this.sortStateInit[k].state = this.sortState[k].state
      this.sortStateInit[k].order = this.sortState[k].order
    }

    if (this.shops) {
      this.shopSearch()
    }
    if (!utils.isBlank(this.$route.params.clinicId)) {
      this.clinicId = this.$route.params.clinicId
    }

    this.search(readMore)

    // オートコンプリートイベント
    utils.autocompleteEvent({
      $:                  $,
      elem:               '#clinic_name_autocomplete',
      search:             this.search,
      searchParams:       false,
      searchAutocomplete: this.getClinics,
      setSearchData:      this.setSearchClinic,
      clear:              this.clearClinicsAutocomplete,
    })

    // 最下部スクロールイベント
    utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
  },
  mounted () {
    // ヘルプボタン表示
    utils.helpModalShow()
  },
  computed: {
    clinicsAutocomplete() {
      return this.$store.getters.clinicsAutocomplete
    },
    doctors() {
      return this.$store.getters.doctors
    },
    loading() {
      return this.$store.getters.apiLoading
    },
    nextPage() {
      return this.$store.getters.doctorsNextPage
    },
    totalCount() {
      return this.$store.getters.doctorsTotalCount
    },
    currentPage () {
      return this.$store.getters.doctorsCurrentPage
    },
    shops() {
      return this.$store.getters.shops
    },
    /** 通知 */
    notify() {
      return this.$store.getters.doctorNotify
    }
  },
  methods: {
    goFacilities: function () {
      this.$router.push({ path: '/facilities', query: { type: this.$router.currentRoute.query.type } })
    },
    goFacilityPersons: function () {
      this.$router.push({ path: '/facility_persons', query: { type: this.$router.currentRoute.query.type } })
    },
    goCareOffices: function () {
      this.$router.push({ path: '/care_offices', query: { type: this.$router.currentRoute.query.type } })
    },
    goClinic: function (id) {
      this.$router.push({ path: '/clinics/' + id, query: { type: this.$router.currentRoute.query.type } })
    },
    goClinics: function () {
      this.$router.push({ path: '/clinics', query: { type: this.$router.currentRoute.query.type } })
    },
    goDoctors: function () {
      this.$router.push({ path: '/doctors', query:{type: this.$router.currentRoute.query.type} })
      this.clinicId = null
      this.clearSearchParams()
      this.search(false)
      // オートコンプリートイベント
      utils.autocompleteEvent({
        $:                  $,
        elem:               '#clinic_name_autocomplete',
        search:             this.search,
        searchParams:       false,
        searchAutocomplete: this.getClinics,
        setSearchData:      this.setSearchClinic,
        clear:              this.clearClinicsAutocomplete,
      })
      // 最下部スクロールイベント
      utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
    },
    goCareManagers: function () {
      this.$router.push({ path: '/care_managers', query: { type: this.$router.currentRoute.query.type } })
    },
    goNext: function (id) {
      if (utils.isBlank(this.$route.params.clinicId)) {
        this.$router.push({ path: '/doctors/' + id, query: { type: this.$router.currentRoute.query.type } })
      } else {
        // クリニック指定
        this.$router.push({ path: '/doctors/' + id + '/' + this.$route.params.clinicId, query: { type: this.$router.currentRoute.query.type } })
      }
    },
    goPrev: function () {
      this.$router.push({ path: '/' })
    },
    goNewEdit: function () {
      if (utils.isBlank(this.$route.params.clinicId)) {
        this.$router.push({ path: '/doctors/edit', query: { type: this.$router.currentRoute.query.type } })
      } else {
        // クリニック指定
        this.$router.push({ path: '/doctors/edit/' + this.$route.params.clinicId, query: { type: this.$router.currentRoute.query.type } })
      }
    },
    hasClinicId() {
      return utils.isPresent(this.$route.params.clinicId)
    },
    search: function (readMore, mode) {
      var clear = true
      var loadparams = 'true'
      var url = '/doctors'
      var self = this

      if (readMore === 'sort') {
        // ソート読み込み
        clear       = false
        loadparams  = 'block'
      } else if (readMore === 'keepload') {
        // 再読込
        clear = false
        loadparams = 'block'
        this.searchCallbackFlag = true

        // スクロール位置
        var pageYOffset = this.$store.getters.doctorsSearchParams['pageYOffset']
        var scrollHeight = this.$store.getters.doctorsSearchParams['scrollHeight']
        this.$store.getters.doctorsSearchParams['pageYOffset'] = null
        this.$store.getters.doctorsSearchParams['scrollHeight'] = null
        this.watchScroll = utils.setScrollHeight(scrollHeight, pageYOffset)
      } else if (readMore) {
        // 次ページ
        url = this.$store.getters.doctorsNextPageLink
        clear = false
        loadparams = 'block'
      } else {
        this.searchCallbackFlag = false
      }

      var callback = function () {
        self.searchCallbackFlag = true
      }

      var data = {
        'shop_id':          this.shopId,
        'clinic_name':      this.clinicName,
        'doctor_name':      this.doctorName,
        'type':             'list',
        'duplicate_flag':   this.duplicatedSearch,
        'clinic_id':        this.clinicId,
        'order':            this.orderByString()
      }
      if (readMore === 'sort' || readMore === 'keepload') {
        // ソート、再読込 現在のページを指定
        data['current_page'] = this.currentPage
      } else {
        data['current_page'] = null
      }
      window.sessionStorage.setItem('dl-shopID', this.shopId)
      if (!!this.clinicName) {
        window.sessionStorage.setItem('dl-clinicName', this.clinicName)
      } else {
        window.sessionStorage.removeItem('dl-clinicName')
      }
      if (!!this.doctorName) {
        window.sessionStorage.setItem('dl-doctorName', this.doctorName)
      } else {
        window.sessionStorage.removeItem('dl-doctorName')
      }
      if (!!this.sortKey) {
        window.sessionStorage.setItem("dl-sortKey", this.sortKey)
      } else {
        window.sessionStorage.removeItem("dl-sortKey")
      }
      if (this.sortStateOrder !== "") {
        window.sessionStorage.setItem("dl-sortStateOrder", this.sortStateOrder)
      } else {
        window.sessionStorage.removeItem("dl-sortStateOrder")
      }

      this.$store.dispatch('CLINIC_AUTOCOMPLETE_CLEAR', 0)
      this.$store.dispatch('DOCTOR_SEARCH', { url: url, data: data, clear: clear, loadparams: loadparams, callback: callback})
    },
    clearSearchParams: function () {
      if (this.$store.getters.canManage && this.shopId === null) {
        this.shopId = this.$store.getters.currentShopId
      }
      this.doctorId = null
      this.doctorName = null
      this.clinicId = null
      this.clinicName = ''
      this.$store.dispatch('DOCTOR_CLEAR', 0)
    },
    getClinics: function () {
      this.clinicId = null
      this.searchClinics()
    },
    searchClinics: function () {
      var clear = false
      var autocomplete = true
      var send_fails = 0

      var data = {
        'shop_id': this.shopId,
        'clinic_name': this.clinicName,
        'send_fails': send_fails
      }
      this.$store.dispatch('CLINIC_SEARCH', { clear: clear, data: data, autocomplete: autocomplete, loadparams: false})
    },
    clearClinicsAutocomplete: function () {
      this.$store.dispatch('CLINIC_AUTOCOMPLETE_CLEAR', 500)
    },
    setSearchClinic: function (clinicId, clinicName) {
      this.clinicName = clinicName
      this.clinicId = clinicId
      this.$store.dispatch('CLINIC_AUTOCOMPLETE_CLEAR', 100)
    },
    duplicatedTel: function () {
      this.duplicatedSearch = !this.duplicatedSearch
      this.search(false)
    },
    getDuplicatedTelClass: function (flag) {
      return flag ? 'btn-success' : 'btn-default'
    },
    shopSearch: function () {
      // this.$store.dispatch('SHOP_SEARCH')
      this.$store.dispatch('SHOP_SEARCH', {data: {all_get: true}, 'allShopName': this._self.$t('AllShopName'), callback: () => {}})
    },
    sortBy: function(key) {
      this.sortKey = key
      this.sortStateOrder = !this.sortState[key].order
      for (var k in this.sortState) {
        this.sortState[k].state = false
        if (k !== key) {
          this.sortState[k].order = false
        }
      }
      this.sortState[key].state = true
      this.sortState[key].order = !this.sortState[key].order

      // 検索
      this.search('sort')
    },
    getArrow: function(key) {
      var state = this.sortState[key].state ? ' color-light-blue' : ''
      var arrow = this.sortState[key].order ? 'fa-arrow-up' : 'fa-arrow-down'
      return arrow + state
    },
    /** ソート文字列取得 */
    orderByString: function() {
      var result = []
      for (var key in this.sortState) {
        if (this.sortState[key].state) {
          var asc_desc = 'asc'
          if (!this.sortState[key].order) {
            asc_desc = 'desc'
          }
          if (key === 'address') {
            result.push('post_no ' + asc_desc)
            result.push('address1 ' + asc_desc)
            result.push('address2 ' + asc_desc)
          } else {
            result.push(key + ' ' + asc_desc)
          }
        }
      }
      if (result.length <= 0) {
        // 存在しない場合
        result.push('doctor_name_furigana asc')
      }
      return result.join(' , ')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/doctor-list.js